import { render } from "./CxLegend.vue?vue&type=template&id=5214c768&scoped=true"
import script from "./CxLegend.vue?vue&type=script&lang=js"
export * from "./CxLegend.vue?vue&type=script&lang=js"

import "./CxLegend.vue?vue&type=style&index=0&id=5214c768&scoped=true&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5214c768"]])

export default __exports__